// neurotrader-admin/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminLayout from './layouts/AdminLayout';
import LoginPage from './pages/LoginPage';
// Vamos criar esta página placeholder
import AdminDashboardPage from './pages/AdminDashboardPage';
import ClientsPage from './pages/ClientsPage';
import OrdersPage from './pages/OrdersPage';
import BotStatsPage from './pages/BotStatsPage';

// Estilos globais básicos
import './index.css';

function App() {
  const { loading } = useAuth();

  if (loading) {
    return <div>Carregando Painel de Administração...</div>;
  }

  return (
      <Router>
        <Routes>
          {/* Rota Pública de Login */}
          <Route path="/login" element={<LoginPage />} />

          {/* Rota "Pai" Protegida para todo o painel */}
          <Route
              path="/"
              element={
                <AdminProtectedRoute>
                  <AdminLayout />
                </AdminProtectedRoute>
              }
          >
            {/* Rotas "Filhas" que aparecem dentro do layout */}
            <Route index element={<AdminDashboardPage />} />
            <Route path="/dashboard" element={<Navigate to="/" />} />
              <Route path="clientes" element={<ClientsPage />} />
              <Route path="pedidos" element={<OrdersPage />} />
              <Route path="bots" element={<BotStatsPage />} />
            {/* Adicionaremos mais rotas aqui (Clientes, Pedidos, etc.) */}
          </Route>
        </Routes>
      </Router>
  );
}

export default App;